import { combineReducers } from '@reduxjs/toolkit'

import addressReducer, {
  initialState as addressInitialState,
} from '~/address/store/address.reducer'
import agentReducer, { initialState as agentInitialState } from '~/agent/store/agent.reducer'
import authReducer, { initialStateAuth } from '~/auth/store/auth.reducer'
import bundlesReducer, {
  initialState as bundlesInitialState,
} from '~/bundles/store/bundles.reducer'
import checkoutReducer, {
  initialState as checkoutInitialState,
} from '~/checkout/store/checkout.reducer'
import contractReducer, {
  initialState as contractInitialState,
} from '~/contract/store/contract.reducer'
import customerReducer, {
  initialState as customerInitialState,
} from '~/customer/store/customer.reducer'
import featureFlagsReducer, {
  initialState as featureFlagsInitialState,
} from '~/featureFlags/store/featureFlags.reducer'
import legalReducer, {
  initialState as legalInitialState,
} from '~/legal/store/legalTexts/legalTexts.reducer'
import nextStepsReducer, {
  initialState as nextStepsInitialState,
} from '~/legal/store/nextSteps/nextSteps.reducer'
import lineReducer, { initialState as lineInitialState } from '~/line/store/line.reducer'
import masterDataReducer, {
  initialState as masterDataInitialState,
} from '~/masterData/store/masterData.reducer'
import modalReducer, { initialState as modalInitialState } from '~/modal/store/modal.reducer'
import paymentsReducer, { paymentsInitialState } from '~/payments/store/payments.reducer'
import pricesReducer, { initialState as pricesInitialState } from '~/prices/store/prices.reducer'
import routerReducer, { initialStateRouter } from '~/router/store/router.reducer'
import saleFlowReducer, {
  saleFormsInitialState,
  saleFormsReducer,
  initialState as saleFlowInitialState,
} from '~/sale/store/sale.reducer'
import tariffReducer, { initialState as tariffInitialState } from '~/tariff/store/tariff.reducer'
import themeReducer, { initialState as themeInitialState } from '~/ui/theme/store/theme.reducer'

export const initialState: RootState = {
  agent: agentInitialState,
  theme: themeInitialState,
  modal: modalInitialState,
  customer: customerInitialState,
  address: addressInitialState,
  line: lineInitialState,
  tariffs: tariffInitialState,
  masterData: masterDataInitialState,
  legalTexts: legalInitialState,
  saleFlow: saleFlowInitialState,
  saleForms: saleFormsInitialState,
  auth: initialStateAuth,
  bundles: bundlesInitialState,
  checkout: checkoutInitialState,
  nextSteps: nextStepsInitialState,
  featureFlags: featureFlagsInitialState,
  contract: contractInitialState,
  prices: pricesInitialState,
  router: initialStateRouter,
  payments: paymentsInitialState,
}

const rootReducer = combineReducers({
  agent: agentReducer,
  theme: themeReducer,
  modal: modalReducer,
  customer: customerReducer,
  address: addressReducer,
  line: lineReducer,
  tariffs: tariffReducer,
  masterData: masterDataReducer,
  legalTexts: legalReducer,
  saleFlow: saleFlowReducer,
  saleForms: saleFormsReducer,
  auth: authReducer,
  bundles: bundlesReducer,
  checkout: checkoutReducer,
  nextSteps: nextStepsReducer,
  featureFlags: featureFlagsReducer,
  contract: contractReducer,
  prices: pricesReducer,
  router: routerReducer,
  payments: paymentsReducer,
})

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
